import React from 'react';

const MENTION = /@\[([^\]]+)\]\(\d+\)/g;

/** Découpe un texte en morceaux { text, mention } : « @[Djibril Diop](123064) » → mention « @Djibril Diop ». */
const segments = (source) => {
    const parts = [];
    let last = 0;
    String(source).replace(MENTION, (match, name, offset) => {
        if (offset > last) parts.push({text: source.slice(last, offset), mention: false});
        parts.push({text: `@${name}`, mention: true});
        last = offset + match.length;
        return match;
    });
    if (last < source.length) parts.push({text: source.slice(last), mention: false});
    return parts;
};

/**
 * Affiche un texte d'opinion ou de commentaire avec les mentions en gras (« @Nom », sans l'identifiant).
 * `maxLength` tronque sur le texte lisible (une mention n'est jamais coupée en deux : elle passe entière ou pas).
 */
const MentionText = ({text, maxLength}) => {
    if (!text) return null;

    let parts = segments(text);
    let truncated = false;
    if (maxLength) {
        let remaining = maxLength - 1;
        const kept = [];
        for (const part of parts) {
            if (remaining <= 0) { truncated = true; break; }
            if (part.text.length <= remaining) {
                kept.push(part);
                remaining -= part.text.length;
            } else {
                if (!part.mention) kept.push({...part, text: part.text.slice(0, remaining)});
                truncated = true;
                break;
            }
        }
        parts = kept;
    }

    return (
        <>
            {parts.map((part, index) => part.mention
                ? <strong key={index}>{part.text}</strong>
                : <React.Fragment key={index}>{part.text}</React.Fragment>)}
            {truncated && '…'}
        </>
    );
};

export default MentionText;
